// Contenu du guide gratuit « Routine anti-chute cheveux afro » (version web imprimable).
export const GUIDE = {
  title: "Routine anti-chute cheveux afro : le guide 12 semaines",
  intro: "Ce guide rassemble, en quelques pages, les gestes qui comptent le plus pour prendre soin de cheveux afro et crépus qui tombent, cassent ou s'affinent. Il s'appuie sur près de 16 ans d'accompagnement de femmes afro par Ozentya. Suivez-le pendant 12 semaines, prenez vos photos et observez honnêtement l'évolution.",
  notice: "Conseils cosmétiques et d'hygiène capillaire, qui ne remplacent pas l'avis d'un médecin ou d'un dermatologue. En cas de chute brutale, de plaques, de douleurs, de rougeurs ou de démangeaisons, consultez. Aucun soin cosmétique ne peut garantir une repousse et les résultats varient d'une personne à l'autre.",
  before: [
    "Prenez 4 photos de départ, à la lumière du jour : tempe droite, tempe gauche, raie au milieu, sommet du crâne.",
    "Ramassez les cheveux perdus dans votre peigne pendant 3 jours : fragments courts sans racine = casse, cheveux entiers avec bulbe blanc = chute.",
    "Retirez toute coiffure qui fait mal ou tire sur les tempes.",
    "Notez ce qui a pu changer ces 3 derniers mois : grossesse, stress, régime, nouvelle coiffure, défrisage.",
  ],
  phases: [
    { weeks: "Semaines 1 à 3", name: "Libérer les racines", steps: [
      "Zéro tension : coiffures basses et lâches, edges au naturel, pas d'extensions lourdes.",
      "1 lavage doux par semaine, en massant le cuir chevelu du bout des doigts.",
      "Après-shampoing à chaque lavage, démêlage sur cheveux mouillés, mèche par mèche, des pointes vers les racines.",
      "Massage de 3 minutes avec une lotion pour le cuir chevelu, 3 à 4 soirs par semaine.",
      "Bonnet ou taie en satin chaque nuit.",
    ] },
    { weeks: "Semaines 4 à 6", name: "Nourrir et retenir", steps: [
      "Ajoutez un masque hebdomadaire de 15 à 30 minutes.",
      "Hydratez les longueurs entre deux lavages (crème à base d'eau), puis scellez avec quelques gouttes d'huile.",
      "Coupez les pointes abîmées si elles font des nœuds.",
      "Continuez la lotion et le massage : c'est la régularité qui compte.",
    ] },
    { weeks: "Semaines 7 à 9", name: "Installer la routine", steps: [
      "Si vous reprenez une coiffure protectrice : pose lâche, tempes libres, 6 à 8 semaines maximum.",
      "Lavez le cuir chevelu sous les tresses toutes les 1 à 2 semaines avec un shampoing dilué.",
      "Reprenez vos photos de la semaine 8 et comparez avec celles du départ.",
    ] },
    { weeks: "Semaines 10 à 12", name: "Faire le point", steps: [
      "Photos de la semaine 12 : même lumière, même angle.",
      "Moins de fragments dans le peigne ? La casse recule. Petits cheveux courts sur le contour ? Gardez le cap.",
      "Aucune amélioration, zones qui s'étendent ou cuir chevelu irrité : prenez rendez-vous chez un dermatologue.",
    ] },
  ],
  temples: [
    "Nettoyez le contour des résidus de gel à chaque lavage.",
    "Massez en petits cercles, sans frotter ni tirer, avec quelques gouttes de lotion.",
    "Gardez le gel et la brosse pour les grandes occasions.",
    "Ne tressez pas les cheveux fins des tempes ; desserrez bandeaux et bonnets de perruque.",
  ],
  avoid: [
    "Nattes collées et tresses très serrées, surtout sur un contour déjà fragilisé.",
    "Extensions lourdes et très longues.",
    "Queues de cheval et chignons tirés en arrière tous les jours.",
    "Perruques collées sur le contour, gardées la nuit.",
    "Défrisage trop fréquent ou superposé sur les longueurs.",
  ],
  tracking: ["Départ", "Semaine 4", "Semaine 8", "Semaine 12"],
  zones: ["Tempe droite", "Tempe gauche", "Raie", "Sommet du crâne", "Fragments dans le peigne"],
  products: ["extreme-repouss", "extreme-repouss-cheveux-fins", "shampoing-cactus", "masque-supreme"],
};
